import React from 'react';
import ErrorPage from 'error/components/';
import { Provider } from 'react-redux';
import { renderToString } from 'react-dom/server';
import App from 'common/containers/app';
import { RouterContext } from 'react-router';

const Server500 = () => {
  const mockRouter = { location: { pathname: 'error' } };
  return (<App>
    <ErrorPage router={mockRouter} />
  </App>);
};

const get500Html = (store, props) => (
  renderToString(<Provider store={store}>
    <RouterContext {...props} components={[Server500]} />
  </Provider>)
);

export default get500Html;



// WEBPACK FOOTER //
// ./error/components/500.jsx